import axios from "axios";
import { showErrorToastDanger } from "../utils/show-toast";

export interface GamerInfo {
  streak: string[];
  username: string;
  avatar: string;
}

const shortUrlFe =
  process.env.REACT_APP_SHORT_URL_FE_URL ?? "https://dev.hyp.gg";
export async function getGamerInfoFromShortCode(
  code: string
): Promise<(GamerInfo & { fullUrl: string }) | undefined> {
  try {
    const url = `${shortUrlFe}/api/get-gamer-info/${code}`;
    const response = (await axios.get(url)).data;
    return response;
  } catch (error) {
    if (
      (axios.isAxiosError(error) && error.response?.status === 404) ||
      (error as any).status === 404
    ) {
      showErrorToastDanger("Invalid code");
      return;
    }
  }
}
